export const APP_FILE_IMPORT_BILL_PAYMENTS_ROUTE = "/import-bills";
export const APP_EXCEL_FILE_IMPORT_BILL_PAYMENTS_ROUTE = APP_FILE_IMPORT_BILL_PAYMENTS_ROUTE + "/excel";
export const APP_PDF_FILE_IMPORT_BILL_PAYMENTS_ROUTE = APP_FILE_IMPORT_BILL_PAYMENTS_ROUTE + "/pdf";
export const APP_EXTRACT_PRODUCST_WITH_API=APP_FILE_IMPORT_BILL_PAYMENTS_ROUTE+"/pdf/extract-and-validate";
export const APP_FILE_IMPORT_INVOICE_PAYMENTS_ROUTE = "/import-payments";